import React from "react";
import { Fab, Tooltip } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface SRFabProps {
    onClick: () => void;
}

export const SRFab: React.FC<SRFabProps> = ({ onClick }) => {
    const { t } = useTranslation("service_request_home");

    return (
        <Tooltip title={t("create_sr")} placement="left">
            <Fab
                color="primary"
                aria-label="create service request"
                onClick={onClick}
                sx={{
                    position: "fixed",
                    bottom: 24,
                    right: 24,
                    zIndex: 40,
                    backgroundColor: "#3A80F4",
                    "&:hover": {
                        backgroundColor: "#2563EB",
                        transform: "scale(1.1)",
                    },
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 20px rgba(58, 128, 244, 0.4)",
                }}
            >
                <AddIcon />
            </Fab>
        </Tooltip>
    );
};

